import { ListItemIcon, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import { mapParentChatbotWithSubChatbotPayload, SubChatbot } from '../../../models/axiosModel';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import globalStyles from "../../../assets/styles/global.module.scss";
import globalStrenameDocumentyles from "../../../assets/renameDocument.svg";
import deleteDoc from "../../../assets/deleteDoc.svg";
import subChatbotStyle from "../../../assets/styles/componentStyles/subChatbotStyles/subChatbot.module.scss";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { secondaryColor } from '../../../utils/colors';

interface SubAiChatbotTableProps {
    subAiChatbotData: SubChatbot[],
    handleEditSubChatbot: (chatbot: SubChatbot) => void,
    handleDeleteSubChatbot: (chatbot: SubChatbot) => void,
}

const SubAiChatbotTable: React.FC<SubAiChatbotTableProps> = (props) => {
    const navigate = useNavigate()
    const { subAiChatbotData, handleEditSubChatbot, handleDeleteSubChatbot } = props;

    const [anchorEl, setAnchorEl] = useState<null | SVGSVGElement>(null);
    const [currentRowIndex, setCurrentRowIndex] = useState<number | null>(null);

    const innerHeight = (window.innerHeight - 280);

    const useStyles = makeStyles(() => ({
        customTooltip: {
            backgroundColor: '#FAFAFA',
            color: '#000',
            boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
            fontSize: '13px',
            padding: '8px 15px',
            borderRadius: 5,
            maxHeight: "400px",
            maxWidth: "400px !important",
            overflow: "auto",
            marginTop: "-10px !important"
        },
        customArrow: {
            color: '#FFF',
            boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
        },
    }));
    const classes = useStyles();

    const menuItem = [
        {
            label: "Edit",
            icon: <img alt="" src={globalStrenameDocumentyles} />,
            action: (chatbot: SubChatbot) => {
                handleEditSubChatbot(chatbot);
            }
        },
        {
            label: "Remove",
            icon: <img alt="" src={deleteDoc} />,
            action: (chatbot: SubChatbot) => {
                handleDeleteSubChatbot(chatbot);
            }
        }
    ]

    const handleMenuOpen = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowIndex: number) => {
        event.stopPropagation();
        event.preventDefault();
        setCurrentRowIndex(rowIndex);
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = (event: React.MouseEvent<HTMLLIElement, MouseEvent> | {}) => {
        //@ts-ignore
        event?.stopPropagation();
        setCurrentRowIndex(null);
        setAnchorEl(null);
    };

    return (
        <>
            <TableContainer className={subChatbotStyle.tableContainer} sx={{ maxHeight: `${innerHeight}px !important` }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Chatbot Id</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Chatbot Name</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Mapping Name</TableCell>
                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Mapping Purpose</TableCell>
                            <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${subChatbotStyle.lastColumnSticky} ${subChatbotStyle.consultationBGColor}`}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subAiChatbotData && subAiChatbotData.length > 0 ?
                            subAiChatbotData.map((chatbot: SubChatbot, ind: number) => {
                                return (
                                    <TableRow key={ind} className={`${dashboardStyles.cellRow} ${globalStyles.clickable}`}>
                                        <TableCell
                                            className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${subChatbotStyle.subChatbotCellStyle}`}
                                            onClick={() => window.open(`/chatbot/viewchatbot/basicdetail?chatbot_id=${chatbot.chatbot_id}`, '_blank')}
                                            sx={{ color: "blue !important", '&:hover': { backgroundColor: `${secondaryColor} !important` } }}
                                        >{chatbot.chatbot_id}</TableCell>
                                        <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${subChatbotStyle.subChatbotCellStyle}`} onClick={() => handleEditSubChatbot(chatbot)}>{chatbot.chatbot_name}</TableCell>
                                        <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${subChatbotStyle.subChatbotCellStyle}`} onClick={() => handleEditSubChatbot(chatbot)}>{chatbot.sub_chatbot_data.sub_chatbot_data_name}</TableCell>
                                        <Tooltip
                                            title={chatbot.sub_chatbot_data.sub_chatbot_data_purpose}
                                            classes={{ tooltip: classes.customTooltip, arrow: classes.customArrow }}
                                            className={subChatbotStyle.toolTipStyle}
                                            placement='bottom-start'
                                        >
                                            <TableCell
                                                className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${subChatbotStyle.purposeMappingStyle} ${subChatbotStyle.subChatbotCellStyle}`}
                                                onClick={() => handleEditSubChatbot(chatbot)}
                                                sx={{ whiteSpace: "normal !important" }}
                                            >
                                                {chatbot.sub_chatbot_data.sub_chatbot_data_purpose}
                                            </TableCell>
                                        </Tooltip>
                                        <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${subChatbotStyle.subChatbotCellStyle} ${subChatbotStyle.lastColumnSticky}`} sx={{ textAlign: "end", lineHeight: '1 !important', backgroundColor: "white !important" }}>
                                            <MoreVertIcon
                                                className={subChatbotStyle.cursorPointer}
                                                onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => handleMenuOpen(e, chatbot.chatbot_id)}
                                            />
                                            <Menu
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl) && chatbot.chatbot_id === currentRowIndex}
                                                onClose={(e) => handleMenuClose(e)}
                                            >
                                                {menuItem.map((item, index) => {
                                                    return (
                                                        <MenuItem
                                                            className={`${globalStyles.menuItemStyle} ${subChatbotStyle.menuItem}`}
                                                            key={index}
                                                            onClick={(e) => { handleMenuClose(e); item.action(chatbot); }}
                                                        >
                                                            <ListItemIcon>
                                                                {item.icon}
                                                            </ListItemIcon>
                                                            <span>
                                                                {item.label}
                                                            </span>
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Menu>
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                            :
                            <TableRow className={dashboardStyles.cellRow}>
                                <TableCell colSpan={12} className={subChatbotStyle.textAlignCenter}>
                                    No Data Available
                                </TableCell>
                            </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default SubAiChatbotTable
